<template>
  <section class="members-footer">
    <div class="members-footer__media">
      <Media
        :images="footerImages"
        cover
        eager
        no-transition
        cover-position="center center"
      />
    </div>
    <div class="members-footer__content">
      <h2 class="members-footer__title">NEED HELP?</h2>
      <p class="members-footer__subtitle">
        For more information on Members Only, see our FAQs or speak to Customer
        Service.
      </p>
      <Button
        theme="secondary"
        tag="a"
        href="mailto:customercare@ratandboa.com"
        form="underline-invert"
        >CONTACT US</Button
      >
    </div>
  </section>
</template>

<script>
import Media from "@/components/Media.vue";
import Button from "@/components/ButtonV3.vue";

export default {
  name: "MembersFooter",
  components: {
    Media,
    Button,
  },
  data() {
    return {
      footerImages: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_2_2_3918b172-a581-405a-a0ac-be8b8b7c151b.jpg?v=1774370196",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_2_2_3918b172-a581-405a-a0ac-be8b8b7c151b.jpg?v=1774370196",
        largeMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_2604.jpg?v=1774370191",
        altText: "",
      },
    };
  },
  methods: {
    openLiveChat() {
      // eslint-disable-next-line no-undef
      certainly.open();
    },
  },
};
</script>

<style lang="scss" scoped>
// Match previous ImageBlock full-width + use-fixed-ratio false heights.
.members-footer {
  position: relative;
  width: 100%;
  margin: 0;
  height: 750px;
  overflow: hidden;

  @include respond-above(md) {
    height: 566px;
  }

  &__media {
    position: absolute;
    inset: 0;

    :deep(.wrapper),
    :deep(.media) {
      height: 100%;
    }

    :deep(.wrapper) {
      max-width: none;
    }
  }

  &__content {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
  }

  &__title {
    @include editorial-headline(32px);
    color: $color-white;
    margin-bottom: 20px;
  }

  &__subtitle {
    @include editorial-body(14px);
    text-transform: none;
    color: $color-white;
    margin-bottom: 30px;
    max-width: 80%;
  }
}
</style>
